import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-checkbox',
  templateUrl: './ui-checkbox.component.html',
  styleUrls: ['./ui-checkbox.component.scss']
})
export class UiCheckboxComponent {
  @Input() public disabled: boolean;
  @Input() public model: any;
  @Input() public size = 'md';
  @Output() public modelChange: EventEmitter<any> = new EventEmitter();

  onChange(event) {
    this.model = event.target.checked;
    this.modelChange.emit(this.model);
  }
}
